import { inject } from '@angular/core';

import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

import { LECKE_ADMIN_ROLE_CODE } from '@shared/constants/mtp-role-codes';

import { UserService } from '@shared/services/user.service';

/**
 * Allows navigation only when `GET /v1/teachers/me` lists the `lecke_admin` MTP role.
 */
export const leckeAdminGuard: CanActivateFn = async () => {
  const userService = inject(UserService);
  const router = inject(Router);

  const teacher = await userService.getMe();
  if (teacher?.roleCodes?.includes(LECKE_ADMIN_ROLE_CODE)) {
    return true;
  }

  return router.createUrlTree(['/']);
};
